import map from 'lodash/map';

import { TResponse } from '@r1-frontend/do-request/core/types';
import { captureQueryError } from '@r1-frontend/do-request/error';
import { IAdvertising } from '@r1-frontend/api-domru/api-content/_dto/IAdvertising';

import contentRequest from '~/src/api/requests/contentRequest';

interface IContentBlock {
    id: number,
    parent_id: number,
    experiment_id: number,
    page_id: number,
    alias: number,
    title: string,
    subtitle: string,
    text_color: string,
    bg_color: string,
    image: string,
    image_webp: string,
    button_text: string,
    link: string,
    created_at: string,
    updated_at: string,
    is_active: boolean,
    advertising?: IAdvertising,
}

export interface IBlockContent {
    id: number,
    title: string,
    desc: string,
    action: string,
    colorText: string,
    img: string,
    imgWebp: string,
    textButton: string,
    bgColor: string,
    advertising?: IAdvertising,
    alias: number,
}

export interface IPageView {
    alias: number,
    bg_color: string,
    contentBlocks: Record<string, IContentBlock>,
    preparedContentBlocks: IBlockContent[],
    created_at: string,
    description: string,
    id: number,
    is_active: boolean,
    legal: string,
    meta_description: string,
    meta_title: string,
    product_type: unknown,
    text_color: string,
    title: string,
    updated_at: string,
}

export type TDataResponse = TResponse<IPageView, any>;

/**
 * @deprecated use 'api-domru/api-content/v1/page/view'
 */
export const getPageView = async(providerId: number, alias: string): Promise<TDataResponse> => {
    const url = `/v1/page/view?id=${alias}`;
    const params = {
        providerId,
    };

    try {
        const { data } = await contentRequest.get(url, { params });

        return {
            isSuccess: true,
            payload: {
                ...data,
                preparedContentBlocks: getBlockInfoArr(data.contentBlocks),
            },
        };
    } catch (error) {
        return captureQueryError(error);
    }
};

const getBlockInfoArr = (data: Record<string, IContentBlock>): IBlockContent[] => {
    return map(data, block => ({
        id: block.id,
        title: block.title,
        desc: block.subtitle,
        action: block.link,
        colorText: block.text_color,
        img: block.image,
        imgWebp: block.image_webp,
        textButton: block.button_text,
        bgColor: block.bg_color,
        advertising: block.advertising,
        alias: block.alias,
    }));
};
